export default __webpack_public_path__ + "static/media/e_wdt_c_1.365f9e94.mp3";